import { useMutation } from "@organizacaox/lai-design-system/query";
import { authClient } from "@/lib/auth-client";

export function useEmailSignIn() {
  return useMutation({
    mutationFn: (input: Parameters<typeof authClient.signIn.email>[0]) =>
      authClient.signIn.email(input),
  });
}
export function useSendVerificationEmail() {
  return useMutation({
    mutationFn: (input: Parameters<typeof authClient.sendVerificationEmail>[0]) =>
      authClient.sendVerificationEmail(input),
  });
}
export function useUpdateProfile() {
  return useMutation({
    mutationFn: (input: Parameters<typeof authClient.updateUser>[0]) =>
      authClient.updateUser(input),
  });
}
